<!--  -->
<template>
  <div class=''>
    <router-view/>
  </div>
</template>

<script>

export default {
  name:'',
  components: {},
  props:{},
  data() {
    return {

    };
  },
  computed: {},
  watch: {},
  created() {
 
  },
  mounted() {

  },
  //方法集合
  methods: {

  },
}
</script>
<style lang='scss' scoped>
  //@import url(); 引入公共css类
  
</style>